// surf_beginner — T1, 4 stages, entardecer sobre o vazio. Recriação livre do
// clássico de CS:S. Maior que antes + ATALHO na sequência de gaps.
import { Course } from '../course';
import type { GameMap } from '../types';
import { finishMap } from './util';

export function buildBeginner(): GameMap {
  const c = new Course(0, 0, 256, 0);

  // === Stage 1: reta larga ===
  c.spawnHere(-224);
  c.zoneOver(c.platform(192, 448), 'start');
  c.drop(544);
  c.ramp(576, 496, 3200);
  c.drop(16);
  c.spawnHere(-224);
  c.zoneOver(c.platform(416, 640), 'stage', { index: 2 });

  // === Stage 2: mais estreita e longa ===
  c.drop(528);
  c.ramp(480, 480, 3800);
  c.drop(16);
  c.spawnHere(-224);
  c.zoneOver(c.platform(416, 640), 'stage', { index: 3 });

  // === Stage 3: gap triplo + ATALHO (lane roxa contínua à esquerda) ===
  c.drop(528);
  c.mark();
  c.shift(-672);
  c.ramp(352, 480, 5100, 'short');
  c.restore();
  c.ramp(544, 480, 1500);
  c.advance(240);
  c.ramp(544, 480, 1500);
  c.advance(360);
  c.ramp(544, 480, 1500);
  c.drop(16);
  c.spawnHere(-224);
  c.zoneOver(c.platform(1024, 640), 'stage', { index: 4 });

  // === Stage 4: reta final gigante ===
  c.drop(544);
  c.ramp(640, 512, 4200);
  c.drop(16);
  c.zoneOver(c.platform(896, 768, 'accent'), 'end');

  return finishMap(c, 'surf_beginner');
}
